import { getTokens, getTokenValue, isWeb } from "@tamagui/core";
import { getRGBA } from "./convertColor";
const getRadiusTokenValue = (radiusToken) => getTokens().radius[radiusToken].val, getSizeTokenValue = (sizeToken) => getTokens().size[sizeToken].val, getSpaceTokenValue = (spaceToken) => getTokens().space[spaceToken].val, getOpacityTokenValue = (opacityToken) => getTokens().opacity[opacityToken].val, getStateTokenValue = (stateToken) => getTokens().state[stateToken].val, getShadowProps = (shadowToken) => {
  const tokens = getTokens(), shadowOpacity = tokens.shadowOpacity[shadowToken].val;
  return {
    shadowColor: isWeb ? getRGBA(getTokenValue(shadowToken, "color"), shadowOpacity) : shadowToken,
    shadowOpacity,
    shadowOffset: {
      width: tokens.shadowOffsetWidth[shadowToken].val,
      height: tokens.shadowOffsetHeight[shadowToken].val
    },
    shadowRadius: tokens.shadowRadius[shadowToken].val,
    elevationAndroid: tokens.elevation[shadowToken].val
  };
}, getPercentageTokenValue = (percentageToken) => getTokens().percentages[percentageToken].val;
export {
  getOpacityTokenValue,
  getPercentageTokenValue,
  getRadiusTokenValue,
  getShadowProps,
  getSizeTokenValue,
  getSpaceTokenValue,
  getStateTokenValue
};
